import React from 'react'
import CurrencyFormatter from '../CurrencyFormatter'
import './TotalPrice.css'

function TotalPrice({ amount }) {
  return <div className='totalPrice'>Total: {<CurrencyFormatter amount={amount} />}</div>
}

export default TotalPrice
